import * as Tooltip from "@radix-ui/react-tooltip";

const CustomTooltip = ({
  content,
  children,
  side = "top",
  align = "center",
  className = "",
  delayDuration = 200,
}) => {

  return (
    <Tooltip.Provider delayDuration={delayDuration}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            align={align}
            sideOffset={6}
            className={`${className} z-[100] rounded-md px-2 py-1 text-xs shadow-md bg-fill-neutral-surface-dark text-ink-white dark:bg-fill-border dark:text-ink-hex-222222 `}
          >
            {content}
            <Tooltip.Arrow
              className="fill-ink-neutral-surface-dark dark:fill-ink-border"
            />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default CustomTooltip;
